import React from 'react';
import styles from './Footer.module.css';
import SocialIcons from './SocialIcons';
import EmailIcon from '@mui/icons-material/Email';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { CONTACT_EMAIL, WHATSAPP_SUPPORT_DISPLAY, getWhatsAppSupportLink } from '../../consts/ContactConfig';
import { resetCookieConsent } from '../cookieConsent/cookieConsentStorage';

/**
 * Componente de Footer reutilizável para toda a aplicação
 */
function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <SocialIcons />

      {/* Seção de contato com email e WhatsApp de suporte */}
      <div className={styles.supportContact}>
        <a
          href={`mailto:${CONTACT_EMAIL}`}
          className={styles.supportEmail}
          aria-label="Enviar email para equipe"
          title="Enviar email para a equipe"
        >
          <EmailIcon className={styles.emailIcon} />
          {CONTACT_EMAIL}
        </a>
        <a
          href={getWhatsAppSupportLink()}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.supportEmail}
          aria-label="Falar no WhatsApp"
          title="Falar no WhatsApp"
        >
          <WhatsAppIcon className={styles.emailIcon} />
          {WHATSAPP_SUPPORT_DISPLAY}
        </a>
      </div>

      <p>© {currentYear} Gabriela — Todos os direitos reservados.</p>
      <p>
        <a href="/novidades">Novidades</a>
        {' · '}
        <a href="/terms-privacy" target="_blank" rel="noopener noreferrer">Termos de uso e Política de privacidade</a>
        {' · '}
        <a
          href="#cookies"
          onClick={(e) => {
            e.preventDefault();
            resetCookieConsent();
          }}
        >
          Cookies
        </a>
      </p>
    </footer>
  );
}

export default Footer;